var _templateObject, _templateObject2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import React from 'react';
import styled from 'styled-components';
import { Tag } from '@finect/tabular-icons/tag';
import { BarChart } from '@finect/tabular-icons/barChart';
import { TrendingUp } from '@finect/tabular-icons/trendingUp';
import { HelpCircle } from '@finect/tabular-icons/helpCircle';
import { ETFs } from '@finect/tabular-icons/etfs';
import { Euro } from '@finect/tabular-icons/euro';
import { ShoppingCart } from '@finect/tabular-icons/shoppingCart';
import { maxMediaQueries } from '@finect/tabular-utils/mediaQueries';
import { getFont } from '@finect/tabular-utils/getFont';
import { Link } from 'react-router-dom';
import { shortcuts } from '../data';
const Shortcuts = styled.div.withConfig({
  displayName: "SearchShortcuts__Shortcuts",
  componentId: "sc-1g6l6n-0"
})(["display:flex;flex-wrap:wrap;justify-content:center;margin-top:18px;small{display:block;min-width:100%;margin-bottom:9px;color:", ";text-align:center;}"], _ref => {
  let {
    theme
  } = _ref;
  return theme.colors.fontL;
});
const Shortcut = styled.a.withConfig({
  displayName: "SearchShortcuts__Shortcut",
  componentId: "sc-1g6l6n-1"
})(["display:flex;align-items:center;flex-direction:column;justify-content:center;width:130px;height:130px;border-radius:", ";margin:12px;background-color:", ";font-weight:600;color:", ";text-align:center;transition:color 0.15s ease;user-select:none;&:hover{color:", ";}svg{margin-bottom:9px;}", ";", ";"], _ref2 => {
  let {
    theme
  } = _ref2;
  return theme.borderRadius;
}, _ref3 => {
  let {
    theme
  } = _ref3;
  return theme.colors.uiLL;
}, _ref4 => {
  let {
    theme
  } = _ref4;
  return theme.colors.font;
}, _ref5 => {
  let {
    theme
  } = _ref5;
  return theme.linkColor;
}, maxMediaQueries.tablet(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    width: 100px;\n    height: 100px;\n    margin: 8px;\n\n    svg {\n      width: 40px;\n      margin-bottom: 8px;\n    }\n  "]))), maxMediaQueries.phablet(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    width: 84px;\n    height: 84px;\n    margin: 3px;\n    ", ";\n\n    svg {\n      width: 36px;\n      margin-bottom: 3px;\n    }\n  "])), getFont(-1, 'compact')));
export const SearchShortcuts = _ref6 => {
  let {
    finectApp,
    onLinkClick
  } = _ref6;
  const baseURL = "https://".concat(process.env.FINECT_BASEURL || 'www.finect.com');
  const getIcon = icon => {
    const iconProps = {
      size: '48',
      strokeWidth: '1'
    };
    switch (icon) {
      case 'topics':
        return React.createElement(Tag, iconProps);
      case 'funds':
        return React.createElement(TrendingUp, iconProps);
      case 'questions':
        return React.createElement(HelpCircle, iconProps);
      case 'planes':
        return React.createElement(BarChart, iconProps);
      case 'invertir':
        return React.createElement(ShoppingCart, iconProps);
      case 'etfs':
        return React.createElement(ETFs, _extends({}, iconProps, {
          strokeWidth: "4"
        }));
      default:
        return React.createElement(Euro, iconProps);
    }
  };
  return React.createElement(Shortcuts, null, React.createElement("small", null, "Tambi\xE9n puedes acceder a"), shortcuts.map((shortcut, index) => {
    const linkProps = shortcut.app === finectApp ? {
      to: shortcut.path,
      as: Link
    } : {
      href: "".concat(baseURL).concat(shortcut.path)
    };
    return React.createElement(Shortcut, _extends({
      key: index,
      "data-fi-event": "omninav-shortcut",
      onClick: () => {
        onLinkClick();
      }
    }, linkProps), getIcon(shortcut.icon), shortcut.text);
  }));
};